define( function() {

return function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/traversing/var/siblings.js
// module id = 92
// module chunks = 0